import { BrowserRouter, Route, Routes } from "react-router-dom"
import { Container } from "./routerStyle"
import Header from "./components/screens/Header"
import Content from "./components/screens/Content"
import Auth from "./components/pages/Auth"
import Done from "./components/pages/Done"
import TokenError from "./components/pages/TokenError"
import ECRule from "./components/pages/ECRule"
import ECRegist from "./components/pages/ECRegist"
import ECDone from "./components/pages/ECDone"
import SaveEnergyRegist from "./components/pages/SaveEnergyRegist"
import Finish from "./components/pages/Finish"
import SaveEnergyDone from "./components/pages/SaveEnergyDone"
import MergePoint from "./components/pages/MergePoint"
import ECGeneralRule from "./components/pages/ECGeneralRule"
import ECGeneralRegist from "./components/pages/ECGeneralRegist"
import ECGeneralDone from "./components/pages/ECGeneralDone"
const Router = (props: any) => { 
  return (    
    <Container>
      <Header/>
      <Content>
        <BrowserRouter>    
          <Routes>    
            <Route path="/done" element={<Done/>} />  
            <Route path="/token-error" element={<TokenError/>} />  
            <Route path="/ec-rule" element={<ECRule/>} />  
            <Route path="/ec-regist" element={<ECRegist/>} />  
            <Route path="/ec-done" element={<ECDone/>} />  
            <Route path="/save-energy-regist" element={<SaveEnergyRegist/>} />  
            <Route path="/save-energy-done" element={<SaveEnergyDone/>} />  
            <Route path="/merge-point" element={<MergePoint/>} />  
            <Route path="/ec-general-rule" element={<ECGeneralRegist/>} />  
            <Route path="/ec-general-regist" element={<ECGeneralRegist/>} />  
            <Route path="/ec-general-done" element={<ECGeneralDone/>} />  
            <Route path="/" element={<Auth/>} />  
          </Routes>    
        </BrowserRouter>    
      </Content>
    </Container>
  )
}
export default Router
